import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { pageTitle } from 'ember-page-title';
import GeneralEmbeddedApp from 'lumen/components/general/embedded-app';
import type HotelRevpakSpiderDashboardController from 'lumen/controllers/hotel/revpak/spider-dashboard';
import contextualPageTitle from 'lumen/helpers/contextual-page-title';
import getEnv from 'lumen/helpers/get-env';

interface HotelRevpakSpiderDashboardSignature {
  Args: {
    controller: HotelRevpakSpiderDashboardController;
    model: unknown;
  };
}

<template>
  {{pageTitle (contextualPageTitle (t "menu.spider.revpak"))}}

  <GeneralEmbeddedApp
    {{! @glint-expect-error: Incorrect type }}
    @baseURL={{getEnv "spiderIframeURL"}}
    @id="spider-revpak"
    @query={{@controller.iframeQPs}}
    @url={{@controller.urlForEmbeddedApp}}
  />
</template> satisfies TOC<HotelRevpakSpiderDashboardSignature>;
